import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// "Test spillet": the game as a participant sees it, in practice mode (nothing is saved). Phone-sized frame.
export default function GamePreviewDialog({ gameCode, seconds, open, onClose }: { gameCode: string; seconds: number; open: boolean; onClose: () => void }) {
  const [t] = useTranslation("global");
  const [lastScore, setLastScore] = useState<number | null>(null);
  const [key, setKey] = useState(0);

  let src = "";
  let origin = "";
  try {
    const url = new URL(gameCode);
    url.searchParams.set("mode", "practice");
    url.searchParams.set("seconds", String(seconds || 10));
    url.searchParams.set("round", `admin-test-${key}`);
    src = url.toString();
    origin = url.origin;
  } catch {
    src = "";
  }

  useEffect(() => {
    const handle = (event: MessageEvent) => {
      if (event.origin === origin && event.data?.type === "breefer:score") setLastScore(Number(event.data.score));
    };
    window.addEventListener("message", handle);
    return () => window.removeEventListener("message", handle);
  }, [origin]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle>{t("games.testTitle")}</DialogTitle>
      <DialogContent>
        {src ? (
          <Box sx={{ width: 360, height: 640, maxWidth: "80vw", maxHeight: "70vh", border: "1px solid #ddd", borderRadius: "12px", overflow: "hidden" }}>
            <iframe key={key} src={src} title="game" style={{ width: "100%", height: "100%", border: 0 }} allow="autoplay" sandbox="allow-scripts allow-same-origin" />
          </Box>
        ) : (
          <Typography color="error.main">{t("games.invalidAddress")}</Typography>
        )}
        <Typography variant="body2" sx={{ mt: 1 }}>
          {lastScore === null ? t("games.testHint") : t("games.testScore", { score: lastScore })}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined"  onClick={() => { setLastScore(null); setKey(key + 1); }}>
          {t("games.restart")}
        </Button>
        <Button variant="contained" sx={{ "&:hover": { backgroundColor: "#D55A07" } }} onClick={onClose}>
          {t("games.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
